import { render, staticRenderFns } from "./ModalAddProducts.vue?vue&type=template&id=51ac1bac&scoped=true"
import script from "./ModalAddProducts.vue?vue&type=script&lang=js"
export * from "./ModalAddProducts.vue?vue&type=script&lang=js"
import style0 from "./ModalAddProducts.vue?vue&type=style&index=0&id=51ac1bac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51ac1bac",
  null
  
)

export default component.exports